import React from 'react'
import { Sidebar } from 'primereact/sidebar';
import classes from './Sidebar.module.css';
import {Link, useLocation} from 'react-router-dom'


const SidebarComponent = ({visible,handle,categories}) => {

  const {pathname} = useLocation()
  console.log(pathname)

  return (
    <Sidebar visible={visible} position="left" onHide={handle } className={classes.sidebar}>
    <div>
      <p className={classes.title}>Video Categories</p>
      <ul className={classes.list}>
      {
        pathname !== '/mis-data' && 
        <Link to={`/home`}>
            <li className={classes.list_item}>Home</li>
            </Link>
      }
        {
          categories && categories.map((category, index) =>(
            <Link to={`/videos/${category}`} key={index}>
            <li className={classes.list_item}>{category}</li>
            </Link>
          ))
        }
        {
            pathname !== '/mis-data' && 
          
          <div className={classes.list_item}>
                <Link to={`/profile`}>Profile</Link>
              </div>
            }
        {
          pathname !== '/mis-data' && 
            <Link to={`/faq`}>
            <li className={classes.list_item}>FaQ's</li>
            </Link>
        }
      </ul>
    </div>
    </Sidebar>
  )
}

export default SidebarComponent
